import React, { use } from "react";
import { useEffect } from "react";
const AuthInput = ({
  name,
  value,
  setError,
  onChange,
  placeholder,
  type = "text",
  buttonText,
  onButtonClick,
  loading = false,
  disabled = false,
  error,
  leftIcon,
  rightIcon,
  setValue,
  step,
  inputWidthClass = "w-[60%] sm:w-[70%]", // default width
}) => {
  useEffect(() => {
    setError("");
  }, [value]);
  // useEffect(() => {
  //   setValue("");
  // }, [step]);
  useEffect(() => {
    // Clear input only if step changes to something other than EMAIL
    if (step !== "EMAIL") {
      setValue("");
    }
  }, [step]);
  return (
    <div className="w-full sm:w-[50%] m-auto">
      <div className="flex items-center justify-between rounded-lg border-[0.5px] border-primary relative">
        {/* LEFT ICON */}
        {leftIcon && (
          <div className="mr-2 text-gray-400 flex items-center">{leftIcon}</div>
        )}
        {/* INPUT */}
        <input
          name={name}
          type={type}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          disabled={disabled}
          className={`${
            leftIcon ? "pl-2" : "pl-4"
          } ${inputWidthClass} outline-none text-sm text-primary font-normal py-[12px] rounded-lg bg-transparent`}
        />

        {/* RIGHT ICON */}
        {rightIcon && (
          <div className="text-gray-400 flex items-center cursor-pointer pr-2">
            {rightIcon}
          </div>
        )}

        {/* BUTTON (Optional) */}
        {buttonText && (
          <button
            type="button"
            onClick={onButtonClick}
            disabled={loading}
            className="cursor-pointer outline-none text-xs bg-buttonColor text-white h-9 min-w-[92px] px-3 rounded-md mr-2 flex items-center justify-center whitespace-nowrap disabled:opacity-70 disabled:cursor-not-allowed"
          >
            {loading ? "Please wait..." : buttonText}
          </button>
        )}
      </div>

      {/* ERROR */}
      {error && <p className="text-red-500 text-xs pt-2 text-start">{error}</p>}
    </div>
  );
};

export default AuthInput;
